import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Shield, Target, Users } from 'lucide-react';
export function TrustSection() {
  return <section className="py-20 bg-white" data-id="element-157">
      <div className="container mx-auto px-4" data-id="element-158">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-159">
          <motion.div className="lg:w-1/2" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-160">
            <div className="relative rounded-lg overflow-hidden shadow-2xl" data-id="element-161">
              <img src="https://cdn.magicpatterns.com/uploads/5kuPCq46Rm4PeCSVBFnz2w/Facility.jpg" alt="NTA Taekwondo Facility" className="w-full h-full object-cover" data-id="element-162" />
              <div className="absolute inset-0 bg-red-900/10 mix-blend-multiply" data-id="element-163" />
            </div>
          </motion.div>

          <motion.div className="lg:w-1/2" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-164">
            <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-6" data-id="element-165">
              Why Families Choose Our Taekwondo School
            </h2>

            <p className="text-lg text-neutral-600 mb-8 leading-relaxed" data-id="element-166">
              Taekwondo is more than kicks and punches. It teaches respect,
              discipline, goal-setting, and perseverance. Our students develop
              physical strength, mental focus, and confidence that carries over
              into school, sports, and everyday life.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10" data-id="element-167">
              <div className="flex flex-col items-center text-center p-4 bg-neutral-50 rounded-lg" data-id="element-168">
                <Shield className="w-8 h-8 text-red-700 mb-2" data-id="element-169" />
                <span className="font-bold text-neutral-900" data-id="element-170">Respect</span>
              </div>
              <div className="flex flex-col items-center text-center p-4 bg-neutral-50 rounded-lg" data-id="element-171">
                <Target className="w-8 h-8 text-red-700 mb-2" data-id="element-172" />
                <span className="font-bold text-neutral-900" data-id="element-173">Focus</span>
              </div>
              <div className="flex flex-col items-center text-center p-4 bg-neutral-50 rounded-lg" data-id="element-174">
                <Users className="w-8 h-8 text-red-700 mb-2" data-id="element-175" />
                <span className="font-bold text-neutral-900" data-id="element-176">Community</span>
              </div>
            </div>

            <Button href="/signup" data-id="element-177" />
          </motion.div>
        </div>
      </div>
    </section>;
}